/**
 * Catalogo de musica del juego.
 *
 * COMO AGREGAR TU PROPIA CANCION (real o estilo K-pop, libre de derechos):
 *   1) Copia el archivo de audio (.mp3 o .ogg) dentro de:  public/assets/music/
 *      Ejemplo:  public/assets/music/ritmo.mp3
 *   2) Agrega (o descomenta) una entrada en MUSIC_TRACKS de abajo con:
 *        - key:  un nombre unico interno (ej: 'music-rhythm')
 *        - file: la ruta dentro de assets (ej: 'music/ritmo.mp3')
 *        - bpm:  los "pulsos por minuto" de la cancion (para que Ritmo vaya al compas).
 *                Si no sabes el BPM, deja 120; podes ajustarlo despues hasta que se sienta bien.
 *   3) Asegurate de que SCENE_MUSIC apunte esa escena a tu key (ya estan mapeadas).
 *
 * Mientras una escena no tenga su archivo cargado, suena la musica generada por codigo
 * (fallback), asi el juego nunca se queda en silencio.
 *
 * IMPORTANTE (derechos de autor): no uses las canciones originales de artistas reales.
 * Usa musica libre de regalias (royalty-free), generada por IA u original tuya.
 */

/** Una pista de musica que se puede cargar desde un archivo. */
export interface MusicTrack {
  /** Clave interna unica (se usa para referenciarla desde SCENE_MUSIC). */
  readonly key: string;
  /** Ruta del archivo dentro de la carpeta public/assets (ej: 'music/ritmo.mp3'). */
  readonly file: string;
  /** Pulsos por minuto: define el compas para sincronizar el minijuego de Ritmo. */
  readonly bpm: number;
}

/**
 * Pistas disponibles. Por defecto esta vacio (todo usa la musica generada por codigo).
 * Descomenta o agrega entradas a medida que subas tus archivos a public/assets/music/.
 */
export const MUSIC_TRACKS: readonly MusicTrack[] = [
  // { key: 'music-hub',       file: 'music/hub.mp3',       bpm: 120 },
  // { key: 'music-rhythm',    file: 'music/ritmo.mp3',     bpm: 128 },
  // { key: 'music-adventure', file: 'music/aventura.mp3',  bpm: 124 },
  // { key: 'music-trivia',    file: 'music/trivia.mp3',    bpm: 110 },
  // { key: 'music-memory',    file: 'music/memoria.mp3',   bpm: 100 },
  // { key: 'music-dressup',   file: 'music/moda.mp3',      bpm: 115 },
];

/**
 * Que pista usar en cada escena (por su clave de escena). Si la pista no tiene archivo
 * cargado todavia, esa escena usa la musica generada por codigo automaticamente.
 */
export const SCENE_MUSIC: Readonly<Record<string, string>> = {
  HubScene: 'music-hub',
  RhythmScene: 'music-rhythm',
  AdventureScene: 'music-adventure',
  TriviaScene: 'music-trivia',
  MemoryScene: 'music-memory',
  DressUpScene: 'music-dressup',
};

/** BPM de referencia para la musica generada por codigo (cuando no hay archivo). */
export const SYNTH_BPM = 111;

/** Busca una pista por su clave. */
export function findTrack(key: string): MusicTrack | undefined {
  return MUSIC_TRACKS.find((track) => track.key === key);
}
